<div class="container">
  <mat-card>
    <mat-card-title class="text-center mt-4"
      >Evaluator Registration</mat-card-title
    >
    <mat-card-content>
      <div [formGroup]="signUpForm">
        <div class="row">
          <div class="col-lg-6">
            <mat-form-field appearance="outline">
              <mat-label>First Name</mat-label>
              <input
                type="text"
                matInput
                placeholder="Enter First Name"
                formControlName="firstName"
              />
            </mat-form-field>
          </div>
          <div class="col-lg-6">
            <mat-form-field appearance="outline">
              <mat-label>Last Name</mat-label>
              <input
                type="text"
                matInput
                placeholder="Enter Last Name"
                formControlName="lastName"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input
              type="email"
              matInput
              placeholder="Enter Email"
              formControlName="email"
            />
          </mat-form-field>
        </div>
        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Job Title</mat-label>
            <input
              type="text"
              matInput
              placeholder="Enter Job Title"
              formControlName="jobTitle"
            />
          </mat-form-field>
        </div>
        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Office</mat-label>
            <mat-select formControlName="officeType">
              <mat-option
                *ngFor="let item of officeTypes"
                [value]="item.value"
                >{{ item.name }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <div class="row" *ngIf="signUpForm.value.officeType == 2">
          <mat-form-field appearance="outline">
            <mat-label>Sub Office</mat-label>
            <mat-select formControlName="subOffice">
              <mat-option
                *ngFor="let item of subOfficeTypes"
                [value]="item.value"
                >{{ item.name }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Password</mat-label>
            <input
              [type]="hidePassword ? 'password' : 'text'"
              matInput
              type="password"
              placeholder="Enter Password"
              formControlName="password"
            />
            <mat-icon matSuffix (click)="hidePassword = !hidePassword">{{
              hidePassword ? "visibility_off" : "visibility"
            }}</mat-icon>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Confirm Password</mat-label>
            <input
              [type]="hidePassword ? 'password' : 'text'"
              matInput
              type="password"
              placeholder="Confirm Password"
              formControlName="confirmPassword"
            />
            <mat-icon matSuffix (click)="hidePassword = !hidePassword">{{
              hidePassword ? "visibility_off" : "visibility"
            }}</mat-icon>
          </mat-form-field>
          <mat-error
            *ngIf="
              signUpForm.hasError('mismatch') &&
              signUpForm.get('confirmPassword').touched
            "
            class="my-2"
            >Passwords do not match.</mat-error
          >
        </div>
        <div class="d-flex flex-row-reverse">
          <div>
            <button
              mat-raised-button
              color="primary"
              class="text-white"
              (click)="onRegister()"
              [disabled]="isLoading || !signUpForm.valid"
            >
              {{ isLoading ? "Submitting" : "Register" }}
            </button>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
